"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSubAccounts = exports.getAssetIdFromTokenId = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const account_1 = require("../../account");
const currencies_1 = require("../../currencies");
const operation_1 = require("../../operation");
const getAssetIdFromTokenId = (tokenId) => tokenId.split("/")[2];
exports.getAssetIdFromTokenId = getAssetIdFromTokenId;
const getAssetIdFromAsset = (asset) => `${asset.asset_code}:${asset.asset_issuer}`;
const buildStellarTokenAccount = ({ parentAccountId, stellarAsset, token, operations, }) => {
    const assetId = (0, exports.getAssetIdFromTokenId)(token.id);
    const id = `${parentAccountId}+${assetId}`;
    const balance = (0, currencies_1.parseCurrencyUnit)(token.units[0], stellarAsset.balance || "0");
    const reservedBalance = new bignumber_js_1.default(stellarAsset.balance).minus(stellarAsset.selling_liabilities || 0);
    const spendableBalance = (0, currencies_1.parseCurrencyUnit)(token.units[0], reservedBalance.toString());
    return {
        type: "TokenAccount",
        id,
        parentId: parentAccountId,
        starred: false,
        token,
        operationsCount: operations.length,
        operations: operations.map(op => {
            var _a;
            return (Object.assign(Object.assign({}, op), { id: (0, operation_1.encodeOperationId)(id, op.hash, op.extra.ledgerOpType), accountId: id, type: op.extra.ledgerOpType, value: (_a = new bignumber_js_1.default(op.extra.assetAmount)) !== null && _a !== void 0 ? _a : op.value }));
        }),
        pendingOperations: [],
        balance,
        spendableBalance,
        swapHistory: [],
        creationDate: operations.length > 0 ? operations[operations.length - 1].date : new Date(),
        balanceHistoryCache: account_1.emptyHistoryCache, // calculated in the jsHelpers
    };
};
const buildSubAccounts = ({ currency, accountId, assets, syncConfig, operations, }) => {
    const { blacklistedTokenIds = [] } = syncConfig;
    const allTokens = (0, currencies_1.listTokensForCryptoCurrency)(currency);
    if (allTokens.length === 0 || assets.length === 0) {
        return undefined;
    }
    const tokenAccounts = [];
    assets.map(asset => {
        const token = (0, currencies_1.findTokenById)(`stellar/asset/${getAssetIdFromAsset(asset)}`);
        if (token && !blacklistedTokenIds.includes(token.id)) {
            tokenAccounts.push(buildStellarTokenAccount({
                parentAccountId: accountId,
                stellarAsset: asset,
                token,
                operations: operations.filter(op => op.extra.assetCode === asset.asset_code &&
                    op.extra.assetIssuer === asset.asset_issuer),
            }));
        }
    });
    return tokenAccounts;
};
exports.buildSubAccounts = buildSubAccounts;
//# sourceMappingURL=tokens.js.map